// @ts-nocheck
/* eslint-disable */
// import { GET_DROPDOWN_TASK_LIST_REQUEST } from "@src/actions/forecast";
import copy from 'utils/cloneObj';
import { numberFormat } from 'utils/format';
import {
  ADD_BULK_TASK_REQUEST,
  ADD_BULK_TASK_SUCCESS,
  CLEAR_DROPDOWN_SUBTASK_LIST, CLEAR_REDUCER,
  DELETE_RESOURCE_ROW,
  DELETE_SUB_TASK_ROW,
  DELETE_TASK_REQUEST,
  DELETE_TASK_SUCCESS,
  GENERATE_RESOURCE_ROW,
  GENERATE_SUB_TASK_ROW,
  GET_BULK_TASK_REQUEST,
  GET_BULK_TASK_SUCCESS,
  GET_DROPDOWN_RESOURCE_LIST_REQUEST,
  GET_DROPDOWN_RESOURCE_LIST_SUCCESS,
  GET_DROPDOWN_SUBTASK_LIST_REQUEST,
  GET_DROPDOWN_SUBTASK_LIST_SUCCESS,
  GET_DROPDOWN_TASK_LIST_SUCCESS,
  HANDLE_RESOURCE_CHANGE,
  HANDLE_SUB_TASK_CHANGE,
  RESET_DELETE_ROW_SUCCESS,
  RESET_GENERATE_ROW_SUCCESS,
  RESET_SELECTED_TASK_ID,
  RESET_TASK,
  SELECT_TASK_FOR_EDIT,
  UPDATE_RESOURCE_ROW,
  UPDATE_TASK_NAME_REQUEST,
  UPDATE_TASK_NAME_SUCCESS,
  UPDATE_TASK_WITH_ERR_MSG,
} from '../constants/taskConstants';

const initialState = {
  loading: false,
  addBulkTaskSuccess: false,
  updateTaskNameSuccess: false,
  deleteTaskSuccess: false,
  deleteRowSuccess: false,
  generateRowSuccess: false,
  task: {},
  dropdownTaskList: [],
  dropdownSubTaskList: {
    ungrouped: [],
    grouped: [],
  },

  getDropdownSubTaskListSuccess: false,
  getDropdownResourceListSuccess: false,

  dropdownResourceList: [],
};

function taskReducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_BULK_TASK_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case GET_BULK_TASK_SUCCESS:
      return getBulkTaskSuccess(state, action);
    case ADD_BULK_TASK_REQUEST:
      return {
        ...state,
        addBulkTaskSuccess: false,
      };

    case ADD_BULK_TASK_SUCCESS:
      return {
        ...state,
        addBulkTaskSuccess: true,
        task: {},
      };

    case UPDATE_TASK_NAME_REQUEST:
      return {
        ...state,
        updateTaskNameSuccess: false,
      };

    case UPDATE_TASK_NAME_SUCCESS:
      return {
        ...state,
        updateTaskNameSuccess: true,
      };

    case DELETE_TASK_REQUEST:
      return {
        ...state,
        deleteTaskSuccess: false,
        loading: true,
      };

    case DELETE_TASK_SUCCESS:
      return {
        ...state,
        deleteTaskSuccess: true,
        task: {},
        loading: false,
      };

    case GENERATE_SUB_TASK_ROW:
      return generateSubTaskRow(state, action);

    case DELETE_SUB_TASK_ROW:
      return deleteSubTaskRow(state, action);

    case GENERATE_RESOURCE_ROW:
      return generateResourceRow(state, action);

    case DELETE_RESOURCE_ROW:
      return deleteResourceRow(state, action);

    case HANDLE_SUB_TASK_CHANGE:
      return handleSubTaskChange(state, action);

    case HANDLE_RESOURCE_CHANGE:
      return handleResourceChange(state, action);

    case UPDATE_RESOURCE_ROW:
      return updateResourceRow(state, action);

    case RESET_DELETE_ROW_SUCCESS:
      return {
        ...state,
        deleteRowSuccess: false,
      };

    case RESET_GENERATE_ROW_SUCCESS:
      return {
        ...state,
        generateRowSuccess: false,
      };

    case UPDATE_TASK_WITH_ERR_MSG:
      return {
        ...state,
        task: {
          ...state.task,
          sub_tasks: action.payload.sub_tasks,
        },
      };

    case RESET_TASK:
      return {
        ...state,
        task: {},
      };

    // case types.RESET_LOADER:
    //   return {
    //     ...state,
    //     loader: false
    //   };

    // case GET_DROPDOWN_TASK_LIST_REQUEST:
    //   return { ...state, updateTaskNameSuccess: false };
    case GET_DROPDOWN_TASK_LIST_SUCCESS:
      return getDropdownTaskList(state, action);

    case GET_DROPDOWN_SUBTASK_LIST_REQUEST:
      return {
        ...state,
        getDropdownSubTaskListSuccess: false,
        dropdownResourceList: [],
      };

    case GET_DROPDOWN_SUBTASK_LIST_SUCCESS:
      return getDropdownSubTaskList(state, action);

    case GET_DROPDOWN_RESOURCE_LIST_REQUEST:
      return {
        ...state,
        getDropdownResourceListSuccess: false,
      };

    case GET_DROPDOWN_RESOURCE_LIST_SUCCESS:
      return getResourceList(state, action);

    case CLEAR_DROPDOWN_SUBTASK_LIST:
      return {
        ...state,
        dropdownSubTaskList: {
          grouped: [],
          ungrouped: [],
        },
      };

    case SELECT_TASK_FOR_EDIT:
      return {
        ...state,
        selectedTaskId: action.payload.taskId,
      };

    case RESET_SELECTED_TASK_ID:
      return {
        ...state,
        selectedTaskId: null,
      };

    case CLEAR_REDUCER:
      return {
        ...state,
        dropdownSubTaskList: {
          ungrouped: [],
          grouped: [],
        },
        dropdownResourceList: [],
      }
    default: {
      return state;
    }
  }
}

const getBulkTaskSuccess = (state, action) => {
  action.payload[0].sub_tasks.forEach((subTask) =>
    subTask.resources.push({
      uid: 1,
      name: '',
      code: '',
      unit: '',
      charge_rate: '',
      quantity: '',
      duration: '1',
    }),
  );

  return {
    ...state,
    loading: false,
    task: { ...action.payload[0] },
  };
};

const generateSubTaskRow = (state, action) => {
  const maxVal = Math.max(
    ...state?.task.sub_tasks?.map((subTask) => subTask.uid).filter(Boolean),
    0,
  );

  return {
    ...state,
    task: {
      ...state.task,
      sub_tasks: [
        ...state.task.sub_tasks,
        {
          uid: maxVal + 1,
          title: '',
          claim_amount: '',
          contract_sum: '',
          budget_sum: '',
          margin: '',
          resources: [
            {
              uid: 1,
              name: '',
              code: '',
              unit: '',
              charge_rate: '',
              quantity: '',
              duration: '1',
            },
          ],
        },
      ],
    },
    generateRowSuccess: true,
  };
};

const deleteSubTaskRow = (state, action) => {
  // if (state.task.sub_tasks.length === 1) {
  //   return state;
  // }
  return {
    ...state,
    task: {
      ...state.task,
      sub_tasks: state.task.sub_tasks.filter((subTask) => {
        if (subTask.id) {
          return subTask.id !== action.payload.subTaskId;
        }

        if (subTask.uid) {
          return subTask.uid !== action.payload.subTaskId;
        }
      }),
    },
    deleteRowSuccess: true,
  };
};

const generateResourceRow = (state, action) => {
  const clonedTask = copy(state.task);
  const selectedSubTask = clonedTask.sub_tasks.find((subTask) => {
    if (subTask.uid) {
      return subTask.uid === action.payload.subTaskId;
    }

    if (subTask.id) {
      return subTask.id === action.payload.subTaskId;
    }
  });

  const resrcMaxVal = Math.max(
    ...selectedSubTask.resources.map((resrc) => resrc.uid).filter(Boolean),
    0,
  );

  selectedSubTask.resources = [
    ...selectedSubTask.resources,
    {
      uid: resrcMaxVal + 1,
      name: '',
      code: '',
      unit: '',
      charge_rate: '',
      quantity: '',
      duration: '1',
    },
  ];
  return {
    ...state,
    task: clonedTask,
    generateRowSuccess: true,
  };
};

const deleteResourceRow = (state, action) => {
  const clonedTask = copy(state.task);

  const selectedSubTask = clonedTask.sub_tasks.find((subTask) => {
    if (subTask.uid) {
      return subTask.uid === action.payload.subTaskId;
    }

    if (subTask.id) {
      return subTask.id === action.payload.subTaskId;
    }
  });

  selectedSubTask.resources = selectedSubTask.resources.filter((resrc) => {
    if (resrc.uid) {
      return resrc.uid !== action.payload.resrcId;
    }

    if (resrc.id) {
      return resrc.id !== action.payload.resrcId;
    }
  });

  const budgetSumArr = [];

  selectedSubTask.resources.forEach((resrc) => {
    budgetSumArr.push(resrc.duration * resrc.charge_rate * resrc.quantity);
  });

  const budgetSum = budgetSumArr.filter(Boolean).reduce((result, item) => {
    return result + item;
  }, 0);

  selectedSubTask.budget_sum = budgetSum;

  // if (selectedSubTask.firstEnteredField) {
  //   if (selectedSubTask.firstEnteredField === 'margin') {
  //     const contractSum = budgetSum / (1 - selectedSubTask.margin / 100);
  //     selectedSubTask.contract_sum = isFinite(contractSum)
  //       ? numberFormat(contractSum)
  //       : '';
  //   }

  //   if (selectedSubTask.firstEnteredField === 'contract_sum') {
  //     const margin =
  //       ((selectedSubTask.contract_sum - budgetSum) /
  //         selectedSubTask.contract_sum) *
  //       100;
  //     selectedSubTask.margin = isFinite(margin) ? numberFormat(margin) : '';
  //   }
  // } else {
  //   const contractSum = budgetSum + (selectedSubTask.margin * budgetSum) / 100;
  //   selectedSubTask.contract_sum = isFinite(contractSum)
  //     ? numberFormat(contractSum)
  //     : '';
  // }

  return {
    ...state,
    task: clonedTask,
    deleteRowSuccess: true,
  };
};

const handleSubTaskChange = (state, action) => {
  const {
    payload: { name, value, subTaskId },
  } = action;

  if (name === 'margin' && +value > 100)
    return {
      ...state,
    };

  const newTask = copy(state.task);

  newTask.sub_tasks.forEach((subTask) => {
    if (subTask.uid === subTaskId || subTask.id === subTaskId) {
      subTask.validateSubTask = true;
      subTask[name] = value;
      subTask[`${name}_err`] = '';

      if (name === 'claim_amount') {
        subTask.change_claim_amount = +subTask.claim_amount;
      }
      if (name !== 'title' || name !== 'claim_amount') {
        const budgetSumArr = [];

        subTask.resources.forEach((resrc) => {
          if (resrc.duration && resrc.charge_rate && resrc.quantity) {
            budgetSumArr.push(
              resrc.duration * resrc.charge_rate * resrc.quantity,
            );
          }
        });

        const budgetSum = budgetSumArr
          // .filter(Boolean)
          .reduce((result, item) => {
            return result + item;
          }, null);

        subTask.budget_sum = budgetSum;

        if (subTask.budget_sum !== null) {
          if (name === 'margin' && !subTask.is_claimed) {
            const contractSum = budgetSum / (1 - subTask.margin / 100);
            subTask.contract_sum = isFinite(contractSum)
              ? numberFormat(contractSum)
              : '';
            subTask.contract_sum_err = '';
          }

          if (name === 'contract_sum') {
            const margin =
              ((subTask.contract_sum - budgetSum) / subTask.contract_sum) * 100;
            subTask.margin = isFinite(margin) ? numberFormat(margin) : '';
            // subTask.margin_err = "";
          }

          if (!subTask.uid) {
            subTask.change_contract_sum = subTask.contract_sum;
          }
        }

        if (!subTask.firstEnteredField && !subTask.is_claimed) {
          subTask.firstEnteredField = name;
        }
      }
    }
  });
  return {
    ...state,
    task: newTask,
  };
};

const handleResourceChange = (state, action) => {
  const {
    payload: { name, value, subTaskId, resrcId },
  } = action;

  const newTask = copy(state.task);
  let resrcNum = null;
  newTask.sub_tasks.forEach((subTask) => {
    if (subTask.uid === subTaskId || subTask.id === subTaskId) {
      subTask.resources.forEach((resrc, i) => {
        if (resrc.uid === resrcId || resrc.id === resrcId) {
          resrc.validateResource = true;
          resrc[name] = value;
          resrc[`${name}_err`] = '';
          resrcNum = i;
          const budgetSumArr = [];

          subTask.resources.forEach((resrc) => {
            if (resrc.duration && resrc.charge_rate && resrc.quantity) {
              budgetSumArr.push(
                resrc.duration * resrc.charge_rate * resrc.quantity,
              );
            }
          });

          const budgetSum = budgetSumArr
            // .filter(Boolean)
            .reduce((result, item) => {
              return result + item;
            }, null);

          subTask.budget_sum = budgetSum;

          if (subTask.budget_sum !== null) {
            if (subTask.firstEnteredField) {
              if (subTask.firstEnteredField === 'margin') {
                const contractSum = budgetSum / (1 - subTask.margin / 100);
                subTask.contract_sum = isFinite(contractSum)
                  ? numberFormat(contractSum)
                  : '';
                subTask.contract_sum_err = '';
              }

              if (subTask.firstEnteredField === 'contract_sum') {
                const margin =
                  ((subTask.contract_sum - budgetSum) / subTask.contract_sum) *
                  100;
                subTask.margin = isFinite(margin) ? numberFormat(margin) : '';
                // subTask.margin_err = "";
              }
            } else {
              const margin =
                ((subTask.contract_sum - budgetSum) / subTask.contract_sum) *
                100;
              subTask.margin = isFinite(margin) ? numberFormat(margin) : '';
              // subTask.margin_err = "";
            }
          }
        }
      });
    }
  });

  const selectedSubTask = newTask.sub_tasks.find(
    (subTask) => subTask.uid === subTaskId || subTask.id === subTaskId,
  );

  if (
    (name === 'name' || name === 'code') &&
    selectedSubTask.resources &&
    selectedSubTask.resources.length - 1 === resrcNum
  ) {
    const resrcMaxVal = Math.max(
      ...selectedSubTask.resources.map((resrc) => resrc.uid).filter(Boolean),
      0,
    );

    selectedSubTask.resources = [
      ...selectedSubTask.resources,
      {
        uid: resrcMaxVal + 1,
        name: '',
        code: '',
        unit: '',
        charge_rate: '',
        quantity: '',
        duration: '1',
      },
    ];
  }

  return {
    ...state,
    task: newTask,
  };
};

const updateResourceRow = (state, action) => {
  const {
    payload: { selectedResourceCode, subTaskId, resrcId },
  } = action;

  const newTask = copy(state.task);
  let resrcNum = null;
  newTask.sub_tasks.forEach((subTask) => {
    if (subTask.uid === subTaskId || subTask.id === subTaskId) {
      subTask.resources.forEach((resrc, i) => {
        if (resrc.uid === resrcId || resrc.id === resrcId) {
          resrc.validateResource = true;
          resrc.name = selectedResourceCode.resource_name;
          resrc.unit = selectedResourceCode.unit;
          resrc.quantity = selectedResourceCode.quantity;
          resrc.charge_rate = selectedResourceCode.rate;
          resrc.code = selectedResourceCode.resource_code;
          resrc.cost_code = selectedResourceCode.cost_code_code;
          resrc.minimum_order_quantity =
            selectedResourceCode.minimum_order_quantity;
          resrc.name_err = '';
          resrc.code_err = '';
          resrc.unit_err = '';
          resrc.charge_rate_err = '';
          resrc.quantity_err = '';
          resrc.duration_err = '';
          resrc.cost_code_err = '';
          resrcNum = i;
          const budgetSumArr = [];

          subTask.resources.forEach((resrc) => {
            if (resrc.duration && resrc.charge_rate && resrc.quantity) {
              budgetSumArr.push(
                resrc.duration * resrc.charge_rate * resrc.quantity,
              );
            }
          });

          const budgetSum = budgetSumArr
            // .filter(Boolean)
            .reduce((result, item) => {
              return result + item;
            }, null);

          subTask.budget_sum = budgetSum;

          if (subTask.budget_sum !== null) {
            if (subTask.firstEnteredField) {
              if (subTask.firstEnteredField === 'margin') {
                const contractSum = budgetSum / (1 - subTask.margin / 100);
                subTask.contract_sum = isFinite(contractSum)
                  ? numberFormat(contractSum)
                  : '';
                subTask.contract_sum_err = '';
              }

              if (subTask.firstEnteredField === 'contract_sum') {
                const margin =
                  ((subTask.contract_sum - budgetSum) / subTask.contract_sum) *
                  100;
                subTask.margin = isFinite(margin) ? numberFormat(margin) : '';
                // subTask.margin_err = "";
              }
            } else {
              const margin =
                ((subTask.contract_sum - budgetSum) / subTask.contract_sum) *
                100;
              subTask.margin = isFinite(margin) ? numberFormat(margin) : '';
              // subTask.margin_err = "";
            }
          }
        }
      });
    }
  });

  const selectedSubTask = newTask.sub_tasks.find(
    (subTask) => subTask.uid === subTaskId || subTask.id === subTaskId,
  );

  if (
    selectedSubTask.resources &&
    selectedSubTask.resources.length - 1 === resrcNum
  ) {
    const resrcMaxVal = Math.max(
      ...selectedSubTask.resources.map((resrc) => resrc.uid).filter(Boolean),
      0,
    );

    selectedSubTask.resources = [
      ...selectedSubTask.resources,
      {
        uid: resrcMaxVal + 1,
        name: '',
        code: '',
        unit: '',
        charge_rate: '',
        quantity: '',
        duration: '1',
      },
    ];
  }

  return {
    ...state,
    task: newTask,
  };
};

const getDropdownTaskList = (state, action) => {
  const dropdownTaskList = action.payload.map((task) => ({
    value: task.id,
    label: task.title,
    ...task,
  }));
  return {
    ...state,
    dropdownTaskList,
    dropdownTaskListWithAll: [{ value: 'all', label: 'All' }].concat(
      dropdownTaskList,
    ),
  };
};

const getDropdownSubTaskList = (state, action) => {
  const groupedObj = {};

  action.payload.forEach((subTask) => {
    if (groupedObj[subTask.task_name]) {
      groupedObj[subTask.task_name].options.push({
        value: subTask.id,
        label: subTask.title,
        ...subTask,
      });
    } else {
      groupedObj[subTask.task_name] = {
        label: subTask.task_name,
        options: [{ value: subTask.id, label: subTask.title, ...subTask }],
      };
    }
  });

  return {
    ...state,
    dropdownSubTaskList: {
      ungrouped: action.payload.map((subTask) => ({
        value: subTask.id,
        label: subTask.title,
        ...subTask,
      })),
      grouped: Object.keys(groupedObj).map((key) => groupedObj[key]),
    },
    getDropdownSubTaskListSuccess: true,
  };
};

const getResourceList = (state, action) => {
  return {
    ...state,
    dropdownResourceList: action.payload.map((resrc) => ({
      value: resrc.id,
      label: resrc.name,
      ...resrc,
    })),
    getDropdownResourceListSuccess: true,
  };
};

export default taskReducer;
